var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var EnvioGratis = function (_a) {
    var esGratis = _a.esGratis;
    return React.createElement(Gratis, null, esGratis ? " gratis" : null);
};
var Gratis = styled.u(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n  font-weight: bold;\n"], ["\n  text-decoration: none;\n  font-weight: bold;\n"])));
export default EnvioGratis;
var templateObject_1;
